export default __webpack_public_path__ + "static/Calibre-Semibold-94fc73852539d6733dc0d80252c5e3fb.woff2";